import { getFlights } from '@shared/services/services';
import {
  setIsNewSearch,
  saveIsThreeDaysSearch,
  setSearchFlightsResult,
} from '@shared/redux/actions';

export const runFlightsSearch = async ({
  dispatch,
  setSearchResults = () => {},
  setIsLoadingResults = () => {},
  preparedBody,
  checkVersion,
}) => {
  try {
    setIsLoadingResults(true);

    checkVersion({
      type: 'flights',
      infoSearch: preparedBody,
      flightSearchType: preparedBody?.trip_type,
      force: true,
    });

    const body = {
      ...preparedBody,
      trip_legs: preparedBody.dataTripLegs.map(
        ({ origin, destination, date }) => ({
          origin: origin?.iata_code,
          destination: destination?.iata_code,
          departure_date: date,
        })
      ),
    };
    delete body.dataTripLegs;

    const result = await getFlights(body);

    if (result?.error_status !== 200) {
      const emptyResult = { clusters: [], errorMessage: result.message };
      setSearchResults(emptyResult);
      dispatch(setSearchFlightsResult(emptyResult));
    } else {
      setSearchResults(result);
      dispatch(setSearchFlightsResult(result));
    }

    dispatch(
      setIsNewSearch({
        isNewSearch: false,
        originalSearchType: preparedBody.trip_type,
      })
    );
    dispatch(
      saveIsThreeDaysSearch({
        oneWay: false,
        roundTrip: false,
        new_go_date: null,
        new_back_date: null,
      })
    );
  } catch (error) {
    console.error('❌ Error fetching flights:', error);
    const emptyResult = { clusters: [], errorMessage: 'Error de conexión' };
    setSearchResults(emptyResult);
    dispatch(setSearchFlightsResult(emptyResult));
  } finally {
    setIsLoadingResults(false);
  }
};
